import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import { apiCRMv3 } from "../../services/api";

import Swal from "sweetalert2";
import * as moment from "moment-timezone";

const UsersConsortiumAvaliableSent = (props) => {
    const [users, setusers] = useState([]);
    const [usersToShow, setUsersToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [dtBegin, setDtBegin] = useState(moment().startOf("day").format("YYYY-MM-DD"));
    const [dtEnd, setDtEnd] = useState(moment().endOf("day").format("YYYY-MM-DD"));

    useEffect(function () {
        const firstDay = moment.tz("America/Sao_Paulo").startOf("day").toDate().toISOString();
        const now = moment.tz("America/Sao_Paulo").endOf("day").toDate().toISOString();
        console.log(firstDay, now)
        loadList(firstDay, now);
    }, []);

    async function loadList(start, end) {
        setLoaded(false);

        const responseUsers = await apiCRMv3.get(`/exclusive-consortium/analyse`, {
            params: { start, end }
        });
        setusers(responseUsers.data.client_list);
        setUsersToShow(responseUsers.data.client_list);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const originalUsers = users;

        if (searchText === "") {
            setUsersToShow(originalUsers);
            setLoaded(true);
            return;
        }

        let filteredUsers = originalUsers.filter(
            (users) =>
                users.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) !== -1
        );

        setUsersToShow(filteredUsers);
        setLoaded(true);
    }

    const handleSearch = async () => {
        setLoaded(false);
        await Promise.all([
            loadList(dtBegin, dtEnd),

        ])

        setLoaded(true)
    };

    return (
        <Layout
            menuActive="registers"
            pageTitle="Lista de Recebidos e Enviados"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div>
                <form>
                    <div className="col-xs-2">
                        <label htmlFor="dtBegin-filter">
                            Data Inicial
                        </label>
                        <input
                            className="form-control"
                            type="date"
                            id="dtBegin-filter"
                            value={dtBegin}
                            onChange={(e) => setDtBegin(e.target.value)}
                        />
                    </div>

                    <div className="col-xs-2">
                        <label htmlFor="dtEnd-filter">
                            Data Final
                        </label>
                        <input
                            className="form-control"
                            type="date"
                            id="dtEnd-filter"
                            value={dtEnd}
                            onChange={(e) => setDtEnd(e.target.value)}

                        />
                    </div>

                    <div
                        className="col-xs-2"
                        style={{
                            transform: "translateY(70%)",
                        }}
                    >
                        <button
                            className="btn btn-primary btn-large"
                            type="button"
                            onClick={handleSearch}
                        >
                            Buscar
                        </button>
                        &nbsp;&nbsp;
                        <button
                            className="btn btn-warning btn-large"
                            type="button"
                            onClick={() => window.location.reload()}
                        >
                            Limpar
                        </button>
                    </div>
                </form>
                <br></br> <br></br> <br></br>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                Lista de Recebidos e Enviados
                            </div>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Filial</th>
                                                <th>Disponibilizados</th>
                                                <th>Enviados</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {usersToShow.map(
                                                (user, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    user.username
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    user.branchlongcode
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    user.total_clients
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    user.total_sended
                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(UsersConsortiumAvaliableSent);
